export const arrayContains = (array: any[], needle: any): boolean => {
    return array.indexOf(needle) !== -1
}

export const arrayUnique = (array: any[]): any[] => {
    return array.filter((item: any, idx: number, arr: any[]) => {
        return arr.indexOf(item) === idx
    })
}

export function flatMap<T extends unknown, R extends unknown>(array: T[], map: (item: T, idx: number) => R[]): R[] {
    const interim = array.map(map)
    return interim.reduce((a, b) => a.concat(b), [])
}

export const arrayObjectIndex = (array: any[], needleKey: string, needleValue: any) => {
    let index = -1

    array.some((item: any, idx: number) => {
        if (item[needleKey] === needleValue) {
            index = idx
            return true
        }

        return false
    })

    return index
}

export const arrayRemove = (arr: any[], entryFinder: any): any[] => {
    let entryIndex: number | undefined

    if (typeof entryFinder === 'function') {
        entryIndex = arr.findIndex(entryFinder)
    } else {
        entryIndex = arr.indexOf(entryFinder)
    }

    if (entryIndex !== undefined && entryIndex !== -1) {
        arr.splice(entryIndex, 1)
    }

    return arr
}

export const arraySortByStringProp = (array: any[], property: string, model?: any): any[] => {
    property = model ? model[property] : property
    const cb = () => {
        return ({ [property]: aProp }: any, { [property]: bProp }: any) =>
            aProp.toLowerCase() > bProp.toLowerCase() ? 1 : aProp.toLowerCase() < bProp.toLowerCase() ? -1 : 0
    }

    return array.sort(cb())
}

export const arraySortByModelGetter = (array: any[], getter: string): any[] => {
    const cb = (): any => {
        return (a: any, b: any) => {
            return a[getter]() > b[getter]() ? 1 : a[getter]() < b[getter]() ? -1 : 0
        }
    }

    return array.sort(cb())
}

export function parseArrayOrNull<T>(from: ArrayLike<T>): T[] | null {
    return from ? Array.from(from) : null
}
